import React from 'react';
import { createUseStyles } from 'react-jss';

import { useToggle } from '../../hooks/useToggle';
import SearchFilter from './SearchFilter';

const useStyles = createUseStyles((theme) => ({
  searchFilterMobile: {
    composes: 'flexColumn',
  },
  searchFilter: {
    visibility: 'hidden',
  },
  button: {
    width: '100%',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    padding: 10,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    lineHeight: 1.5,
    fontWeight: 400,
    fontSize: 14,
    color: '#3a56e4',
    backgroundColor: '#ffffff',
    border: '1px solid #3a56e4',
    borderRadius: 4,
    cursor: 'pointer',
    '&:focus': {
      outline: 'none',
    },
  }
}));

const SearchFilterMobile = ({ className }) => {
  const classes = useStyles();

  const { open, toggle } = useToggle();

  return (
    <div className={classes.searchFilterMobile}>
      <button type="button" onClick={toggle} className={classes.button}>
        {open ? 'Save Filters' : 'Show Filters'}
      </button>
      {open && <SearchFilter />}
    </div>
  );
}

export default SearchFilterMobile;